module.exports = __webpack_public_path__ + "static/media/backIcon.fcea3128.svg";